import { HashRouter as Router } from 'react-router-dom';
import Content from '@context/Content';
import Header from '@components/Header';
import styled from '@emotion/styled';
import Footer from '@components/Footer';
import { AccountProvider } from '@hooks/AccountContext';
import { SHOW_HEADER } from '@utils/globals';

const AppContainer = styled.div(() => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
}));

function App() {
    return (
        <Router>
            <AppContainer>
                <AccountProvider>
                    { SHOW_HEADER ? <Header /> : null }
                    <Content />
                    <Footer />
                </AccountProvider>
            </AppContainer>
        </Router>
    );
}

export default App;
